exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\r\n * Created by Rumyantsev Daniil on 12.02.2018.\r\n */\r\n.modal-header {\r\n  background-color: #51b6dc;\r\n  color: white;\r\n}\r\n.modal-body {\r\n  margin-bottom: 1rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/shared-module/modal-window/modal-window.component.css
// module id = ../../../../../src/app/shared-module/modal-window/modal-window.component.css
// module chunks = 5